// removed by extract-text-webpack-plugin
module.exports = {"NavItem":"NavItem__NavItem__3OmF-","active":"NavItem__active__jieu3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavItems/NavItem/NavItem.css
// module id = 46
// module chunks = 0